import React from 'react';
import { FilterConfig } from '../types';
import { useGetCountriesQuery } from 'src/services/settings/country/goCountry';
import { useTranslation } from 'react-i18next';
import CountryFlag from 'src/components/common/CountryFlag';
import Select from 'src/UI/Select/Select';
import { Option, OptionValue, SelectThemes } from 'src/UI/Select/types';

interface IProps {
  item: FilterConfig;
  onChange: (value: OptionValue) => void;
  propsValue: number;
  className?: string;
  controllerClassName?: string;
}

const CountrySelect = ({
  item,
  onChange,
  propsValue,
  className,
  controllerClassName,
}: IProps) => {
  const { t: tg } = useTranslation('translation');
  const { data } = useGetCountriesQuery({ is_active: 1 });
  return (
    <Select
      theme={SelectThemes.FROM_TABLE}
      hasSearch={
        item.selectConfig?.hasSearch === undefined ||
        item.selectConfig.hasSearch
      }
      onChange={onChange}
      propsValue={propsValue}
      className={className}
      controllerClassName={controllerClassName}
      disablePortal={false}
      options={
        [
          {
            title: tg('select-all'),
            value: null,
            isControllerHidden: true,
          },
          ...(data?.countries || []).map((country) => ({
            title: country.name.ua,
            value: country.name.en,
            searchValue: country.name.ua,
            element: (
              <CountryFlag
                emoji={country.emoji}
                nameEn={country.name.en}
                iso2={country.iso2}
              />
            ),
          })),
        ] as Option[]
      }
    />
  );
};

export default CountrySelect;
